import { authorizedFetch } from "./requestBuilder.js";

const API_BASE = process.env.REACT_APP_API_URL + "/api/notifications";

export const getMyNotifications = async () => {
  try {
    return await authorizedFetch(`${API_BASE}`, {
      method: "GET",
      headers: { "Content-Type": "application/json" },
    });
  } catch (error) {
    console.error("Error fetching notifications:", error);
    throw error;
  }
};

export const markNotificationAsRead = async (notificationId) => {
  try {
    return await authorizedFetch(`${API_BASE}/${notificationId}`, {
      method: "DELETE",
      headers: { "Content-Type": "application/json" },
    });
  } catch (error) {
    console.error("Error deleting notifications:", error);
    throw error;
  }
};
